<template>
  <v-dialog v-model="dialog" persistent eager scrollable max-width="600">
    <v-card>
      <v-card-title class="secondary white--text">
        <v-icon class="white--text" left>not_listed_location</v-icon>
        Come funziona?
        <v-spacer></v-spacer>
        <v-btn depressed class="white--text" light icon @click="dismiss">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>

      <v-container class="white" style="height: 450px; overflow-y: auto">
        <v-row>
          <v-col>
            <div class="info-row">
              <div class="info-row-icon mr-3">1.</div>
              <div class="info-content">
                <div class="info-title">MODALITA' & OPZIONI</div>
                <div class="info-text">
                  <v-icon color="text" left small>settings</v-icon> Scegli una
                  tra le 4 modalità d'asta (e personalizza le relative opzioni)
                </div>
              </div>
            </div>

            <div class="info-row">
              <div class="info-row-icon mr-3">2.</div>
              <div class="info-content">
                <div class="info-title">SCEGLI IL TUO LAYOUT</div>
                <div class="info-text">
                  Trova la visuale più comoda per seguire l'asta: Tavolo o Panoramica.<br />
                  Usa il pulsante <v-icon color="text" small>view_module</v-icon> / <v-icon color="text" small>view_module</v-icon>
                  nella barra in alto per provare la visuale che ti piace di piú.
                </div>
              </div>
            </div>

            <div class="info-row">
              <div class="info-row-icon mr-3">3.</div>
              <div class="info-content">
                <div class="info-title">AVVIA / STOP</div>
                <div class="info-text">
                  <v-icon color="text" left small>play_arrow</v-icon> Premi Avvia
                  per iniziare l'asta.<br />
                  <v-icon color="text" left small>stop</v-icon> Premi Stop per
                  annullare il round (e quindi riselezionare chi mettere
                  all'asta)
                  <br />
                  PS: In modalitá "Admin Assegna", non essendoci timers, non é necessario "avviare" l'asta.

                </div>
              </div>
            </div>

            <div class="info-row">
              <div class="info-row-icon mr-3">4.</div>
              <div class="info-content">
                <div class="info-title">ET VOILA'</div>
                <div class="info-text">
                  Asta Live ti guiderà in maniera intuitiva sugli step
                  successivi: <br />
                  <v-icon color="text">chevron_right</v-icon>
                  Se tocca a te fare qualche azione (fare offerta, scegliere
                  calciatore da mettere all'asta...) ti si apriranno popup
                  intuitivi.<br />
                  <v-icon color="text">chevron_right</v-icon>
                  Se non tocca a te, potrai seguire l'andamento dell'asta sul
                  tavolo.<br />
                  Man mano che l'asta prosegue, Asta Live aggiornerà tutto in
                  tempo reale
                </div>
              </div>
            </div>

            <div class="info-row" v-if="Config.STANDALONE">
              <div class="info-row-icon">
                <v-icon color="text">download</v-icon>
              </div>
              <div class="info-content">
                <div class="info-title">DOWNLOAD ROSE</div>
                <div class="info-text">Terminata l'asta scarica le rose</div>
              </div>
            </div>

            <div class="info-row" v-else>
              <div class="info-row-icon">
                <v-icon color="text">save</v-icon>
              </div>
              <div class="info-content">
                <div class="info-title">SALVA ROSE</div>
                <div class="info-text">
                  Terminata l'asta ricordati di salvare le rose o non saranno
                  visibili da app/sito.
                </div>
              </div>
            </div>

            <v-divider class="my-4"></v-divider>

            <div class="info-row">
              <div class="info-row-icon">
                <v-icon color="text">check</v-icon>
              </div>
              <div class="info-content">
                <div class="info-title">PARTECIPANTI ONLINE / OFFLINE</div>
                <div class="info-text">
                  Ovviamente dovreste essere tutti online (pallino verde
                  sull'avatar) per uno svolgimento ottimale.<br />
                  Se qualcuno risultasse offline (pallino rosso),
                  l'amministratore d'asta, cliccando sulla squadra sul tavolo,
                  può:<br />
                  <div class="d-flex align-center my-2">
                    <v-icon color="text" class="ma-2">airline_stops</v-icon>
                    Forzarne un "Passo"
                  </div>
                  <div class="d-flex align-center my-2">
                    <v-icon color="text" class="ma-2">person_remove</v-icon>
                    Escluderlo dall'asta (temporaneamente).<br />
                    PS: Utile anche quando una squadra completa il
                    ruolo in cui state ancora chiamando calciatori
                  </div>
                   <div class="d-flex align-center my-2">
                    Su alcuni dispositivi/browser puó capitare che una persona sia online ma gli altri la vedano col pallino rosso.
                    Se la situazione persiste dite a tale persona di refreshare la pagina (o chiudere e riaprire Asta Live).
                  </div>
                </div>
              </div>
            </div>

             <div class="info-row">
              <div class="info-row-icon">
                <v-icon color="error">warning</v-icon>
              </div>
              <div class="info-content">
                <div class="info-title error--text">IMPORTANTE</div>
                <div class="error--text">
                    Asta Live necessita che l'amministratore d'asta (che, vi ricordiamo, non corrisponde necessariamente con l'{{ adminLegaDivisioneLabel }})
                    debba <b>sempre essere online (pallino verde)</b> altrimenti
                    l'asta a un certo punto si bloccherà. E' sempre possibile
                    cambiare tale amministratore durante il corso dell'asta.
                </div>
              </div>
            </div>

            <div class="info-row">
              <div class="info-row-icon">
                <v-icon color="text">forum</v-icon>
              </div>
              <div class="info-content">
                <div class="info-title">CHAT</div>
                <div class="info-text">
                  Usa la chat di Asta Live per animare l'asta durante il suo
                  svolgimento
                </div>
              </div>
            </div>

            <!-- <div class="info-row">
              <div class="info-row-icon">
                <v-icon color="text">settings_backup_restore</v-icon>
              </div>
              <div class="info-content">
                <div class="info-title">ORDINAMENTO SQUADRE</div>
                <div class="info-text">
                  Trascina le card dei partecipanti per modificarne l'ordinamento.<br>
                  L'ordinamento serve per:
                  <ul>
                    <li>L'ordine di chiamata calciatore all'asta</li>
                    <li>Per l'ordine di rilancio in modalità "asta poker"</li>
                  </ul>
                  Ps: solo l'amministratore di lega è abilitato alla modifica dell'ordinamento e può farlo solo mentre l'asta è ferma.  -->
            <!-- NB: Al momento
                  puoi spostarli solo nella visualizzazione con
                  <a
                    @click="mostraCampettoRettangolare"
                    style="text-decoration: underline; cursor: pointer"
                    >tavolo rettangolare</a
                  > -->
            <!-- </div>
              </div>
            </div> -->
          </v-col>
        </v-row>

        <v-row class="text-center">
          <v-col cols="12"> <div>BUON DIVERTIMENTO SU ASTA LIVE!</div></v-col>
          <v-col cols="12"> <v-icon color="text">celebration</v-icon></v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import db from "../../js/db";
import mixins from "../../js/mixins";
import toast from "../../js/toast";

export default {
  name: "asta-come-funziona",
  mixins: [mixins, toast],
  data() {
    return {
      btnDisabled: false,
      dialog: false,
    };
  },
  mounted() {
    console.log("--> AstaComeFunziona ready.");
    db.on("showComeFunziona", this.show);
  },
  destroyed() {
    console.log("<-- AstaComeFunziona destroyed.");
    db.off("showComeFunziona", this.show);
  },
  methods: {
    // mostraCampettoRettangolare() {
    //   db.emit("campetto-rettangolare");
    //   // db.emit("closeDrawer");
    //   this.dismiss();
    // },
    show() {
      this.dialog = true;
    },
    dismiss() {
      this.dialog = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.info-row {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}
.info-row-icon {
  padding-right: 30px;
  padding-left: 15px;
}
.info-title {
  font-weight: bold;
}
</style>
